/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsOrderAlert
 */
export interface DigitizingserviceMelcoDigitizingModelsOrderAlert {
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderAlert
     */
    message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderAlert
     */
    translated_message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderAlert
     */
    direction?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderAlert
     */
    created_date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderAlert
     */
    preview_url?: string | null;
}

export function DigitizingserviceMelcoDigitizingModelsOrderAlertFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsOrderAlert {
    return DigitizingserviceMelcoDigitizingModelsOrderAlertFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsOrderAlertFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsOrderAlert {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
        'translated_message': !exists(json, 'translated_message') ? undefined : json['translated_message'],
        'direction': !exists(json, 'direction') ? undefined : json['direction'],
        'created_date': !exists(json, 'created_date') ? undefined : (json['created_date'] === null ? null : new Date(json['created_date'])),
        'preview_url': !exists(json, 'preview_url') ? undefined : json['preview_url'],
    };
}

export function DigitizingserviceMelcoDigitizingModelsOrderAlertToJSON(value?: DigitizingserviceMelcoDigitizingModelsOrderAlert | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'translated_message': value.translated_message,
        'direction': value.direction,
        'created_date': value.created_date === undefined ? undefined : (value.created_date === null ? null : value.created_date.toISOString()),
        'preview_url': value.preview_url,
    };
}


